import ContainerRegister from "../../componets/ContainerRegister/Register";


export default function Register() {
    return (
        <div className="App">
            <ContainerRegister/>            
        </div>
    )
}